import script from "./BrandDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrandDetail.vue?vue&type=script&lang=ts&setup=true"

import "./BrandDetail.vue?vue&type=style&index=0&id=5816c4aa&lang=scss"

const __exports__ = script;

export default __exports__